import {
    createContext,
    PropsWithChildren,
    useContext
} from 'react';

export interface ChromecastContext { }

export const ChromecastContextProvider = ({ children }: PropsWithChildren) => {

    return (
        <ChromecastContext.Provider
            value={{}}
        >
            {children}
        </ChromecastContext.Provider>
    );
};

export const ChromecastContext = createContext<ChromecastContext | null>({});

// for fucntion components
export const useChromecastContext = () => {
    const chromecastContext = useContext(ChromecastContext);
    // if (!chromecastContext) {
    //     throw new Error('Chromecast was not defined');
    // }
    return chromecastContext;
    // return {
    //     chromecast: null,
    //     setChromecast: () => { },
    //     castDevice: null,
    //     mediaState: null,
    //     setMediaState: () => { },
    //     chromecastItem: null,
    //     setChromecastItem: () => { },
    //     bingeChannel: null,
    //     appStateChannel: null,
    //     warningChannel: null,
    //     // splashChannel: null,
    //     showChromecastBinge: false,
    //     progressTime: null,
    //     setShowChromecastBinge: () => { },
    //     useTimeshiftChannel: null,
    //     useVolumeChannel: null,
    //     useContinueOnPhoneChannel: null,
    //     sessionManager: null,
    //     client: null,
    //     castSession: null,
    //     mediaStatus: null,
    //     devices: [],
    //     castState: null,
    //     activeDevice: null,
    // }
};